/* unplugin-vue-components disabled */import script from "./Details.vue?vue&type=script&lang=ts&setup=true"
export * from "./Details.vue?vue&type=script&lang=ts&setup=true"

import "./Details.vue?vue&type=style&index=0&id=44b68db3&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b68db3"]])

export default __exports__